export const PixarFilms = `
Toy Story,November 1995,199511
A Bug's Life,November 1998,199811
Toy Story 2,November 1999,199911
Monsters Inc.,November 2001,200111
Finding Nemo,May 2003,200305
The Incredibles,November 2004,200411
Cars,June 2006,200606
Ratatouille,June 2007,200706
WALLE,June 2008,200806
Up,May 2009,200905
Toy Story 3,June 2010,201006
Cars 2,June 2011,201106
Brave,June 2012,201206
Monsters University,June 2013,201306
Inside Out,June 2015,201506
The Good Dinosaur,November 2015,201511
Finding Dory,June 2016,201606
Cars 3,June 2017,201706
Coco,November 2017,201711
Incredibles 2,June 2018,201806
Toy Story 4,June 2019,201906
Onward,March 2020,202003
Soul,December 2020,202012
Luca,June 2021,202106
Turning Red,March 2022,202203
Lightyear,June 2022,202206
Elemental,June 2023,202306
Inside Out 2,June 2024,202406
Elio,June 2025,202506
Hoppers,March 2026,202603
`;